import React from "react";

export default function UserPrompt() {
  return (
    <div className="padding-sides" style={{ marginBottom: 60 }}>
      <h1>
        Not enough information. Please fill out more categories to get
        recommended subjects.
      </h1>
    </div>
  );
}
